<template>
  <div>
    <h4 v-if="has_title">{{title}}</h4>
    <select name="select" v-model="selected_order">
      <option value="value1">Value 1</option>
      <option value="value2">Value 2</option>
      <option value="value3">Value 3</option>
    </select>
    <div v-if="is_tolgeo_mex" id="btn_analytics"></div>
    <div>
      <a data-cy="save_search" class="btn btn-link text-uppercase text-small" v-on:click="save_search" title="$t('guardar_busqueda')" v-if="!hide_save_search">
        {{ t('guardar_busqueda') }}
      </a>
    </div>
    <div v-if="showTabs" class="nav nav-tabs">
      <button data-cy="current_search" class="nav-link active">
        {{ search_type }} ({{ num_found.toLocaleString() }})
      </button>
      <a data-cy="related_search" class="nav-link" :href="related_tab.link">
        {{ related_tab.name }} ({{ related_tab.found.toLocaleString() }})
      </a>
    </div>
    <documents-item-vue v-for="document in documents" v-bind:key="document.id" v-bind:search_type='search_type' @save:document="save_document"></documents-item-vue>
    <user-subscription-modal-login-vue ref="user_subscription_login_modal" @login:success="handleLoginSuccess"/>
  </div>
</template>

<script>
import token_formatter from 'common/token_formatter.js'
import mixins from 'common/mixins.js'
import { mapGetters } from "vuex";

export default {
  props: [
    'title',
    'documents',
    'page',
    'rows',
    'num_found',
    'order',
    'loading_documents',
    'search_tokens',
    'token_id',
    'search_type',
    'hide_save_search',
    'hide_save_document',
    'hide_quick_view',
    'related_tab'
  ],
  data() {
    return {
      selected_order: this.order,
      loginSuccessAction: {}
    }
  },
  components: {
    'documents-item-vue': () => import(/* webpackChunkName: "[request]" */ "components/documents/Item"),
    "user-subscription-modal-login-vue": () =>import( /* webpackChunkName: "[request]" */ "components/user_subscription/ModalLogin"),
  },
  computed: {
    has_title() {
      return this.title !== ''
    },
    showTabs() {
      return this.related_tab !== undefined
    },
    activeTabText() {
      if (!this.related_tab) return this.t('.encontrados')

      let doctype = this.t('search.forms.' + this.search_type + '.label')
      return this.t('components.search.list.results_tab', {
        doctype: doctype, found: this.parseNumResults(this.num_found)
      })
    },
    relatedTabText() {
      if (!this.related_tab) return this.t('.resultados')

      let doctype = this.t('search.forms.' + this.related_tab.name + '.label')
      return this.t('components.search.list.related_tab', {
        doctype: doctype, found: this.parseNumResults(this.related_tab.found)
      })
    },
    ...mapGetters(["has_user_subscription"])
  },
  methods: {
    do_paginate() {
      this.$emit('scroll_elements');
    },
    print_result_list(){
      this.$global_utils.print_element('#results_list_container', "result_list")
    },
    save_search() {
      if(this.has_user_subscription){
        this.http_get({
          url: this.url_for_user_subscriptions_search_new({"search[token_id]": this.token_id}),
          format: "JS"
        })
      } else{
        this.loginSuccessAction = {name: 'save_search', attr: {}}
        this.showLoginForm()
      }
    },
    save_document(params){
      if(this.has_user_subscription){
        this.http_get({
          url: this.url_for_user_subscriptions_document_new(params),
          format: "JS"
        })
      }else {
        this.loginSuccessAction = {name: 'save_document', 'attr': params}
        this.showLoginForm()
      }
    },
    showLoginForm() {
      this.$refs.user_subscription_login_modal.show()
    },
    handleLoginSuccess(){
      if(this.loginSuccessAction.name == 'save_document'){
        this.save_document(this.loginSuccessAction.attr)
      }else if (this.loginSuccessAction.name ==  'save_search'){
        this.save_search()
      }
    },
    parseNumResults(numFound) {
      if (numFound === undefined || numFound === null || numFound === 0) {
        return this.t('components.search.searching').toLowerCase() + '...'
      }

      return numFound.toLocaleString()
    }
  },
  watch:{
    // eslint-disable-next-line camelcase, no-unused-vars
    selected_order(new_value, old_value){
      this.$emit('update:order', new_value)
    }
  },
  mixins: [mixins.requests, mixins.translate]
}
</script>
